<template>
    <div>
        <h3 class="leader">
            <span style="margin: 4px 360px 0 0;float: left;"><a-icon :type="roleIcon"/> {{roleName}}</span>
            <a-button @click="create" icon="user-add" type="primary" shape="round" ghost :disabled="!addible">添加{{roleName}}</a-button>
        </h3>
        <a-row :gutter="20" style="min-height: 130px;" v-if="data.length">
            <a-col :key="item.id" span="12" v-for="item in data">
                <div class="member">
                    <a-row :gutter="15">
                        <a-col span="6">
                            <ResourceImg :id="item.user.avatar" resize="m_8,w_100,h_100" v-if="item.user.avatar" width="100%"/>
                            <a-icon style="font-size: 48px;" type="user" v-else/>
                        </a-col>
                        <a-col span="14">
                            <b>{{item.comment[role] || item.user.name || item.user.nick || item.user.mobile}}</b>
                            <div>{{item.user.mobile}}</div>
                        </a-col>
                        <a-col span="4">
                            <a-popconfirm @confirm="remove(item)" title="您确定要删除吗？">
                                <a-icon style="cursor: pointer;" type="delete"/>
                            </a-popconfirm>
                            <div><a-icon style="cursor: pointer;" type="form" @click="update(item)"/></div>
                        </a-col>
                    </a-row>
                </div>
            </a-col>
        </a-row>
        <a-empty v-else style="margin-top: 50px;">
            <template #description>暂未添加{{roleName}}</template>
        </a-empty>
        <MemberForm :album="album" @saved="refresh" ref="memberForm"/>
    </div>
</template>

<script>
    import ResourceImg from "../../../../../comps/ResourceImg";
    import cache from "../../../../../utils/cache";
    import MemberForm from "./MemberForm";
    import enums from "../../../../../utils/enums";

    export default {
        name: "MemberItem",
        components: {MemberForm, ResourceImg},
        props: {
            role: Number,
            data: Array,
            album: Object,
            addible: Boolean,
        },
        computed: {
            roleName() {
                return enums.Role.roleName[this.role];
            },
            roleIcon() {
                return enums.Role.roleIcon[this.role];
            }
        },
        methods: {
            create() {
                this.$refs.memberForm.open(this.role);
            },
            update(item) {
                this.$refs.memberForm.open(this.role, item);
            },
            remove(item) {
                cache.v1.album.member.delete(item.album.id, item.id, this.role).then(this.refresh);
            },
            refresh() {
                this.$emit("refresh");
            }
        }
    }
</script>

<style lang="less" scoped>
    .leader {
        margin: 20px 0;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px #e8e8e8 solid;
    }

    .member {
        padding: 15px;
        margin-bottom: 20px;
        border-radius: 4px;
        line-height: 25px;
        border: 1px #d9d9d9 solid;

        img {
            border-radius: 100%;
            border: 1px #d9d9d9 solid;
        }
    }
</style>
